import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
// import { HttpStatus } from '@core/classes/http-status.class';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router} from "@angular/router";


import { AccessSettingsKeys } from '@app/models/access/settings';
import { AppService } from '@app/services/app/app.service';
import { TitleService } from '@core/services/title.service';

@Component({
    selector: 'settings-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class SettingsMainComponent implements OnInit{
    public readonly SETTINGS_LIST = AccessSettingsKeys;
    // ['tokens_access',
    //                                     'groups_access',
    //                                     'categories_access',
    //                                     'users_access',
    //                                     'rules_access',
    //                                     'versions_access',
    //                                     'workflows_access',
    //                                     'custom_forms'];
    //                                     'organization_profile'];
                    //yes! the pattern of access keys here changed in july 2024 (https://youtu.be/zTDeEJyCmNA?feature=shared&t=41)

    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;

	public accessList: Array<any> = null;
    public forbidden: boolean = true;
    public status: number = 0;


	constructor(public app: AppService, private title: TitleService, private router: Router){}

	ngOnInit(){
        this.title.set("System settings");
        this.app.getSession().subscribe( (session: any) => {
            this.accessList = session.options.access;
            Object.values(this.SETTINGS_LIST).forEach((item: string) => {

                let access = session.options.access.hasOwnProperty(item)? session.options.access[item] : false;

                if(access){
                    this.forbidden = false;
                }

            });
        });
        if (this.accessList){
            this.status = this.STATUS_DONE;
        }
	}


	protected open(setting: string){
        this.router.navigate(['/settings/', setting]);
	}

    public allowed(setting: string){
        return this.accessList.hasOwnProperty(setting)?  this.accessList[setting] : false;

    }

}
